import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  useEffect(() => {
    document.title = "Pago cancelado · Mimes Gourmet";
  }, []);
  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-24 text-center" data-testid="payment-cancel">
      <XCircle className="w-14 h-14 mx-auto text-[color:var(--brand-terracotta)]" strokeWidth={1.2} />
      <h1 className="font-serif text-4xl mt-6 text-[color:var(--brand-primary)] font-light">Pago cancelado</h1>
      <p className="mt-4 text-sm text-[color:var(--brand-neutral)]">
        No te preocupes, tu cesta sigue esperándote.
      </p>
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/tienda">
          <Button variant="outline" className="rounded-md">Seguir comprando</Button>
        </Link>
      </div>
    </div>
  );
}
